import { useEffect, useState } from 'react'
import type { ActiveErrorToast } from '../lib/errorToastRegistry'
import { subscribeToActiveErrorToasts } from '../lib/errorToastRegistry'

export const useActiveErrorToasts = () => {
  const [errorToasts, setErrorToasts] = useState<ActiveErrorToast[]>([])

  useEffect(() => {
    const unsubscribe = subscribeToActiveErrorToasts(setErrorToasts)
    return () => unsubscribe()
  }, [])

  return errorToasts
}
